var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.7577 32 32 24.7577 32 16C32 7.22632 24.7577 0 15.984 0C7.22632 0 0 7.22632 0 16C0 24.7577 7.24227 32 16 32ZM16 29.9262C8.27916 29.9262 2.07378 23.7049 2.07378 16C2.07378 8.27916 8.27916 2.05783 15.984 2.05783C23.7049 2.05783 29.9262 8.27916 29.9422 16C29.9422 23.7049 23.7208 29.9262 16 29.9262ZM22.0778 16.8295C22.6999 16.4626 22.6839 15.6171 22.0778 15.2502L12.9691 9.79462C12.347 9.41176 11.5334 9.71486 11.5334 10.4008V21.6471C11.5334 22.333 12.2991 22.652 12.9691 22.2532L22.0778 16.8295Z",
    fill: "#7B5DF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.e705a46c62f4d02363a82916a77b7e24.svg";
export { ForwardRef as ReactComponent };